<template>
  <div class="card-pane-wrap">
    <div v-for="stats in cardsOptions" :key="stats.title" class="card-pane">
      <stats-card
        :type="stats.type"
        :small-title="stats.title"
        :title="stats.value ? stats.value() : undefined"
        :title-usd="stats.valueUSD ? stats.valueUSD() : undefined"
        :title-usdt="stats.valueUSDT ? stats.valueUSDT() : undefined"
        :loading="stats.loading"
        :class-name="stats.className">
        <template #header>
          <div :class="stats.noStyles ? '' : 'logo'">
            <img :src="stats.logo" alt="">
          </div>
        </template>
        <template v-if="stats.content" #content>
          <component
            :is="stats.content"
            :data="stats.data()"
            :small-title="stats.title"
            :loading="stats.loading"
            :logo="stats.logo"/>
        </template>
        <template v-if="stats.fullContent" #full-content>
          <component
            :is="stats.fullContent"
            :data="stats.data()"/>
        </template>
        <template #footer>
          <div v-if="stats.loading" class="stats stats-footer-dummy">
            <el-icon class="is-loading">
              <Loading/>
            </el-icon>
            {{ loadingText }}
          </div>
          <div v-else class="stats stats-footer-btn" @click="() => handleClick(stats.action)">
            <i :class="stats.footerIcon"/>
            {{ stats.footerText }}
          </div>
        </template>
      </stats-card>
    </div>
  </div>
</template>

<script>
import StatsCard from '@/components/UIComponents/Cards/StatsCard'

export default {
  name: 'CardPane',
  components: {
    StatsCard
  },
  props: {
    cardsOptions: {
      type: Array,
      default: () => [],
    },
    handleClick: {
      type: Function,
      required: true,
    },
    loadingText: {
      type: String,
      default: 'Обновление...',
    }
  }
}
</script>

<style scoped>

</style>
